import React, {useState} from 'react'

import {COVER_SELECTOR_MENU_HEIGHT} from "../../selector-popover"
import FieldsFactory from "../../../../../fields3/fields-factory"
import {FieldType} from "../../../../../fields3/field-type"
import Button from "../../../../buttons/gd-button/gd-button-ui5-new"
import FieldFormElementView from "../../../../../fields3/render/form-elemnent-view"
import {Cover} from "../../../../../model2/task/properties/cover"
import {CoverType} from "../../../cover-type"

type Props = {
    cover?          : Cover

    onCoverSelected : {(cover:Cover):void}
}

// const debug = "CoverSelectorLink"
const debug = false

export default function CoverSelectorLink (props:Props) {

    const initialValue = props.cover?.type === CoverType.LINK ? props.cover?.url : ''
    const [value, setValue] = useState(initialValue)

    const field = FieldsFactory.get({ fieldId: 'link', type: FieldType.STRING })

    const onChange = (newValue:string) => {
        debug && console.log(debug, 'onChange', newValue)
        setValue(newValue)
    }

    const onSave = () => {
        debug && console.log(debug, 'onSave')
        props.onCoverSelected(new Cover({
            type: CoverType.LINK,
            url : value
        }))
    }

    const styles = {
        height: `calc(100% - ${COVER_SELECTOR_MENU_HEIGHT}px)`
    }

    return (
        <div className="cover-link p-l-15 p-t-10 p-r-15 p-b-25" style={styles}>
            <div className="flex-row-left-center ui5-txt-not-important-small h-30 m-b-5">Paste image src</div>
            <FieldFormElementView field={field} model={{link: value}} onChange={onChange}/>

            <div className="flex-row-center-center">
                <Button className   = "w-70 m-t-25"
                        type        = "primary"
                        label       = "Save"
                        onClick     = {onSave}/>
            </div>
        </div>
    )
}
